import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import BlogCopyAction from "./action";
import BlogCopyReview from "./review.js";
import callApi from "../callApi.js";
import "./style.css";


const BlogCopiesTableView = () => {
    const navigate = useNavigate();
    const [allData, setAllData] = useState([]);
    const [responseMessage, setResponseMessage] = useState(
        "There are no records to display"
    );
    const [pending, setPending] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const handleModalClose = () => setShowModal(false);
    const handleModalShow = () => setShowModal(true);

    const [showReviewModal, setShowReviewModal] = useState(false);
    const handleReviewModalClose = () => setShowReviewModal(false);
    const handleReviewModalShow = () => setShowReviewModal(true);

    const [blogCopy, setBlogCopy] = useState({});

    const [buttonDisabled, setButtonDisabled] = useState(false);

    useEffect(() => {
        getBlogCopiesData();
    }, []);

    const getBlogCopiesData = () => {
        setPending(true);
        let url = `${process.env.REACT_APP_API_URL}/v1/content/blog/copies`;
        callApi(url)
            .then((json) => {
                if (json.data && json.data.blog_copies) {
                    setAllData(json.data.blog_copies);
                }
                if (json.status && json.status.message) {
                    setResponseMessage(json.status.message);
                }
                setPending(false);
            })
            .catch((err) => err);
    };

    const saveBlogCopywrites = () => {
        setButtonDisabled(true);
        let url = `${process.env.REACT_APP_API_URL}/v1/content/blog/generated_copy`;
        callApi(url, 'POST', {'blog_copy': {'id': blogCopy.id}})
            .then((json) => {
                setButtonDisabled(false);
                setBlogCopy({});
                handleModalClose();
                getBlogCopiesData();
            })
            .catch((err) => err);
    };

    const deleteBlogCopy = (blog_copy) => {
        setButtonDisabled(true);
        let url = `${process.env.REACT_APP_API_URL}/v1/content/blog/copies`;
        url = url + `?document_ids=${blog_copy.id}`
        callApi(url, 'DELETE')
            .then((json) => {
                setButtonDisabled(false);
                setBlogCopy({});
                handleModalClose();
                getBlogCopiesData();
            })
            .catch((err) => err);
    };

    const saveBlogEntry = () => {
        let url = `${process.env.REACT_APP_API_URL}/v1/content/blog/finalised_entry`;
        callApi(url, 'POST', {'blog_copy': {'id': blogCopy.id}})
            .then((json) => {
                setButtonDisabled(false);
                setBlogCopy({});
                handleReviewModalClose();
                getBlogCopiesData();
            })
            .catch((err) => err);
    };

    const onAddClick = () => {
        navigate('/blog-copies/add');
    }

    return (
        <div className="index-page">
            <h1 className="title">
                Blog Copies
            </h1>
            <div className="index-container">
                <button 
                    className="index-button"
                    onClick={onAddClick}>
                        Add
                </button>
            </div>
            {
                pending ?
                    <div className="loading">
                        Loading...
                    </div> : 
                    allData.length > 0 ?
                        <div className="index-container">
                            <table className="table">
                                <thead className="text-center align-top">
                                    <tr>
                                        <th className="border border-dark dobin-primary">
                                            Topic
                                        </th>
                                        <th className="border border-dark dobin-primary" colSpan="3">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-center align-top">
                                    {
                                        allData.map((blog_copy, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="border border-dark col-md-3">
                                                        {blog_copy.inputs.article_instructions.topic}
                                                    </td>
                                                    <td className={"border border-dark col-md-3"}>
                                                        <button
                                                            className={
                                                                blog_copy.aggregations ?
                                                                "blue-button" : "grey-button"
                                                            }
                                                            onClick={() => {
                                                                setBlogCopy(_.cloneDeep(blog_copy));
                                                                handleModalShow();
                                                            }}
                                                            disabled={buttonDisabled}>
                                                                Edit
                                                        </button>
                                                    </td>
                                                    <td className={"border border-dark col-md-3"}>
                                                        <button
                                                            className={
                                                                blog_copy.outputs ?
                                                                "blue-button" : "grey-button"
                                                            }
                                                            onClick={() => {
                                                                setBlogCopy(_.cloneDeep(blog_copy));
                                                                handleReviewModalShow();
                                                            }}
                                                            disabled={
                                                                blog_copy.outputs ?
                                                                false : true
                                                            }>
                                                                Review
                                                        </button>
                                                    </td>
                                                    <td className={"border border-dark col-md-3"}>
                                                        <button
                                                            className={
                                                                "red-button"
                                                            }
                                                            onClick={() => {
                                                                deleteBlogCopy(blog_copy);
                                                            }}
                                                            disabled={buttonDisabled}>
                                                                Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                        </div> :
                        <div className="loading">
                            {responseMessage}
                        </div>
            }
            <Modal 
                show={showModal} 
                onHide={() => {
                    handleModalClose()
                    setBlogCopy({})
                }} 
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Selected Blog Copy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BlogCopyAction 
                        blogCopy={blogCopy}
                        setBlogCopy={setBlogCopy}
                        handleModalClose={handleModalClose}
                        setButtonDisabled={setButtonDisabled}
                        updateBlogCopyTable={() => {
                            getBlogCopiesData()
                        }} />
                </Modal.Body>
                <Modal.Footer>
                {
                    <div>
                        <button 
                            form="blog-copy-edit"
                            type="submit"
                            className="blue-button"
                            disabled={buttonDisabled}>
                                Aggregate
                        </button>
                        <button
                            className="blue-button"
                            disabled={buttonDisabled}
                            onClick={() => {
                                saveBlogCopywrites();
                            }}>
                                Copywrite
                        </button>
                    </div>
                }
                </Modal.Footer>
            </Modal>
            <Modal 
                show={showReviewModal} 
                onHide={() => {
                    handleReviewModalClose()
                    setBlogCopy({})
                }} 
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Selected Blog Copy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BlogCopyReview
                        blogCopy={blogCopy}
                        setBlogCopy={setBlogCopy}
                        handleModalClose={handleReviewModalClose}
                        setButtonDisabled={setButtonDisabled}
                        updateBlogCopyTable={() => {
                            getBlogCopiesData()
                        }} />
                </Modal.Body>
                <Modal.Footer>
                {
                    <div>
                        <button 
                            form="blog-copy-review"
                            type="submit"
                            className="blue-button"
                            disabled={buttonDisabled}>
                                Update
                        </button>
                        <button
                            className="blue-button"
                            disabled={buttonDisabled}
                            onClick={() => {
                                saveBlogEntry();
                            }}>
                                Approve
                        </button>
                    </div>
                }
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default BlogCopiesTableView;